export default __webpack_public_path__ + "static/media/LandingGift.d717e6f2.svg";